export enum SecondaryNavigationVariants {
  LINE = 'line',
  ENCLOSED = 'enclosed',
  ENCLOSED_COLORED = 'enclosed-colored',
  SOFT_ROUNDED = 'soft-rounded',
  SOLID_ROUNDED = 'solid-rounded',
  UNSTYLED = 'unstyled'
}

export enum SecondaryNavigationOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export type TabData = {
  label: string;
  content?: any;
  children?: TabData[];
  disabled?: boolean;
};
